import { Links, Meta, Outlet, Scripts, ScrollRestoration } from "react-router";
import "./app.css";
import { SiteNav } from "./components/nav/SiteNav";
import { Footer } from "./components/layout/Footer";

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body className="bg-background text-foreground antialiased">
        {children}
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  return (
    <>
      <SiteNav />
      <div className="pt-20">
        <Outlet />
      </div>
      <Footer />
      <ScrollRestoration />
    </>
  );
}
